export const urls = {
    bp: {
        bpls: 'api/{userId}/bpls',
        bp: 'api/{userId}/bp',
        cbp: 'api/{userId}/cbp?',
    },
};
